module.exports = __webpack_public_path__ + "static/bodykom-2fca204d24583d964ed90105e34bfd94.png";